module.exports = __webpack_public_path__ + "static/img/logoFinalMjti.954e8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoFinalMjti.png
// module id = jDP2
// module chunks = 9